import { repositories } from "@/core";

export default {
  name: "ContentDetail",
  mounted() {
    this.loadingItems = true;
    this.getData();

    // const email = this.userSession.email;
    // const keywords = ["phurshell", "vinnie"];
    // this.showSyncOfflineContentButton = keywords.some((elem) =>
    //   email.includes(elem)
    // );
  },
  data() {
    return {
      item: {},
      id: this.$route.params.id,
      parentCategory: null,
      loadingItems: false,
      copied: false,
      showSyncOfflineContentButton: true,
      syncing: false,
    };
  },
  components: {
  },
  computed: {
    userSession() {
      return this.$store.state.userSession;
    },
  },
  methods: {
    async getData() {
      try {
        const res = await repositories.contentsService.show(this.id);
        let data = res.data;
        this.$set(this, "item", data);
        this.getContentCategory(res.data.content_category_id);
      } catch (e) {
        console.log(e);
      }
    },
    async getRefContent(id) {
      try {
        let res = await repositories.contentsService.show(id);
        this.$set(this, "parentCategory", res.data);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    async getContentCategory(id) {
      try {
        let res = await repositories.contentsService.showCategory(id);
        res.data.type = "category";
        this.$set(this, "parentCategory", res.data);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    handleDelete() {
      this.$eventBus.$emit("showConfirmationAlert", {
        message: "Deseja excluir esse conteúdo permanentemente?",
        confirmCallback: async () => {
          try {
            repositories.contentsService.delete(this.id);
            this.$eventBus.$emit("showToast", {
              type: "danger",
              title: "Conteúdo excluído",
              msg: `Conteúdo excluído com sucesso`,
            });

            let path = this.parentCategory?.count_subcategory
              ? `${this.$paths.contents.subcategories.list}/${this.parentCategory?.id}`
              : `${this.$paths.contents.list}/${this.parentCategory?.id}`;

            this.$router.push({ path: path });
          } catch (e) {
            console.log(e);
          }
        },
      });
    },
    copyURL(hyperlink) {
      this.$set(this, "copied", true);
      setTimeout(() => {
        this.$set(this, "copied", false);
      }, 3000);
      this.$helper.copyUrlWithHyperlinkTag(this.$route.path, hyperlink);
    },
    async syncOfflineContent() {
      try {
        this.syncing = true;
        await repositories.contentsService.syncOfflineContent({
          content_id: this.id,
        });
        alert("Conteúdo offline atualizado com sucesso");
        this.getData();
      } catch (error) {
        console.error(error);
        alert("Erro ao atualizar conteúdo offline");
      } finally {
        this.syncing = false;
      }
    },
  },
};
